<sm-title-bar pageTitle="{{ 'pay_credits.title' | translate }}" [backWithParams]="true" >
    <ng-template #addButton>
        <div class="d-flex search-field" (click)="payCredit()">
          <button mat-flat-button color="accent" style="border: 1px solid #FFC107 !important;
          color: #ffffff !important;
          border-radius: 6px;
          background-color: #FFC107;
          width: 180px;">
            <mat-icon class="material-icons-round" [inline]="true"
              >add</mat-icon
            >
            {{ 'pay_credits.btn_txt' | translate }}
          </button>
         
        </div>
      </ng-template> </sm-title-bar>
<mat-card >
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light" *ngIf="!loader">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="expenseData" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         >
      </sm-data-table>
    </div>
  </mat-card>
  

  
  <ng-template #menuTemplate let-rowvalue>
    
    <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>{{ 'pay_credits.op1_view_details' | translate }}</span>
    </button>
    <!-- <button mat-menu-item (click)="addPayback(rowvalue)">
      <mat-icon class="material-icons-outlined">add</mat-icon>
      <span>{{ 'pay_credits.op2_add_payback' | translate }}</span>
    </button>
    <button mat-menu-item (click)="deleteCredit(rowvalue)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>{{ 'pay_credits.op3_delete' | translate }}</span>
    </button> -->
    <!-- <button mat-menu-item *ngIf="rowvalue.status == 1 && rowvalue.toShowType =='parent'" (click)="openAddTime(rowvalue)">
      <mat-icon class="material-icons-outlined">link</mat-icon>
      <span>Add more</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.status == 1" (click)="removeTime(rowvalue)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Remove</span>
    </button> -->
  </ng-template>
  <!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->